<template>
  <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="carga_masiva_estudiante">
    <h4 class="title-secondary">Carga masiva de colaboradores</h4>
    
    <div class="row">
      <div class="col-md-6">
        <small>Puedes cargar una lista de colaboradores desde un archivo de carga masiva...</small>
        
        <div v-if="empresas.length > 0" class="mt-4">
          <label class="form-label">Seleccionar empresa</label>
          <select v-model="selectedUrl" class="form-control rounded-8 sin-borde py-2">
            <option value="">Seleccionar empresa para la carga masiva</option>
            <option v-for="client in empresas" :key="client.id" :value="client.url">
              {{ client.client }}
            </option>
          </select>
        </div>
        
        <div class="mt-3">
          <a href="/templates/template_carga_de_usuarios_masivos.csv" download target="_blank" class="text-decoration-underline">
            Descargar plantilla
          </a>
        </div>
      </div>
      
      <div class="col-md-6 d-flex flex-column align-items-end justify-content-center">
        <small v-if="selectedFile" class="mb-3 text-muted">{{ selectedFile.name }}</small>
        
        <div class="upload-area" :class="{ 'uploading': isUploading }">
          <button 
            @click="handleFileSelect" 
            :disabled="isUploading || !selectedUrl"
            class="btn bg-utel text-white rounded-8 upload-btn"
          >
            <i class="fas fa-upload me-2"></i>
            {{ isUploading ? 'Subiendo...' : 'Subir archivo .csv' }}
          </button>
          
          <input 
            ref="fileInput" 
            type="file" 
            accept=".csv" 
            @change="onFileSelected" 
            class="d-none"
          >
        </div>
        
        <small v-if="!selectedUrl && empresas.length > 0" class="text-warning mt-2">
          Selecciona una empresa primero
        </small>
      </div>
    </div>
    
    <!-- Progress indicator -->
    <div v-if="isUploading" class="mt-3">
      <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkUploadStudent',
  
  props: {
    empresas: { type: Array, default: () => [] },
    urlmassive: { type: String, default: '' }
  },
  
  emits: ['upload-success', 'upload-error', 'show-message'],
  
  data() {
    return {
      selectedUrl: this.empresas.length > 0 ? '' : this.urlmassive,
      selectedFile: null,
      isUploading: false
    };
  },
  
  methods: {
    handleFileSelect() {
      if (!this.selectedUrl) {
        this.$emit('show-message', {
          title: 'Advertencia!',
          content: 'Debe seleccionar una empresa para subir registros masivos.'
        });
        return;
      }
      
      this.$refs.fileInput.click();
    },
    
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.uploadFile();
      }
    },
    
    async uploadFile() {
      if (!this.selectedFile || !this.selectedUrl) return;
      
      this.isUploading = true;
      
      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('tipo', 'Estudiante');
        
        const response = await axios.post(this.selectedUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        this.$emit('upload-success', response.data);
        this.$emit('show-message', {
          title: 'Proceso exitoso!',
          content: 'Se ha cargado la información de usuarios masivos correctamente.'
        });
        
        this.resetUpload();
        
      } catch (error) {
        console.error('Upload error:', error);
        
        this.$emit('upload-error', error);
        this.$emit('show-message', {
          title: 'Error!',
          content: 'Hubo un error al procesar el archivo. Verifique el formato y contenido.'
        });
        
        this.resetUpload();
      } finally {
        this.isUploading = false;
      }
    },
    
    resetUpload() {
      this.selectedFile = null;
      this.$refs.fileInput.value = '';
    }
  }
}
</script>

<style scoped>
.title-secondary {
  color: #494949;
  font-weight: bold;
}

.form-label {
  color: #1A0054;
  font-weight: 500;
}

.upload-area {
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.upload-area.uploading {
  background-color: #f8f9fa;
  border: 2px dashed #007bff;
}

.upload-btn {
  min-width: 180px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.progress {
  height: 8px;
  border-radius: 4px;
  background-color: #e9ecef;
}

.progress-bar {
  background-color: #007bff;
}

.text-warning {
  font-size: 0.875rem;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.875rem;
}
</style>